import React, { Fragment } from 'react';
import { Grid } from '@material-ui/core';
import LabelValueCard from './LabelValueCard';
const RevisionAddCard = ({ item, tsprCspr,source }) => {
    const timestamp = new Date(item.timestamp);
    const year = timestamp.getFullYear();
    const month = (timestamp.getMonth() + 1).toString().padStart(2, "0");
    const day = timestamp.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    const tslsvCslsvKeyChange = { ...item?.changes };

    if (tslsvCslsvKeyChange?.removal_tslsv !== undefined) {
        tslsvCslsvKeyChange.tspr = tslsvCslsvKeyChange?.removal_tslsv;
        delete tslsvCslsvKeyChange.removal_tslsv;
    }

    if (tslsvCslsvKeyChange?.removal_cslsv !== undefined) {
        tslsvCslsvKeyChange.cspr = tslsvCslsvKeyChange?.removal_cslsv;
        delete tslsvCslsvKeyChange.removal_cslsv;
    }
    return (
        <Fragment>
            <Grid container spacing={3}>
                <LabelValueCard md={source && item?.additional_data?.source  ? 4 : 6} label='Created at' value={formattedDate} />
                <LabelValueCard md={source && item?.additional_data?.source  ? 4 : 6} label='Created by' value={item.user && item.user.name ? item.user.name : '--'} />
                {source && item?.additional_data?.source  ? <LabelValueCard md={4} label='Source' value={item?.additional_data?.source || '--'} />: null}
            </Grid>
            <div className="edit-detail-table">
                <table>
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    {Object.entries(tsprCspr ? tslsvCslsvKeyChange : item.changes).map(([item, value], index) =>
                        <tbody>
                            <tr key={index}>
                                <td style={{ textTransform: 'capitalize' }}>{item.trim().includes('_') ? item.trim().replace(/[_]/g, ' ') : item}</td>
                                <td>{value}</td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </Fragment>
    )
}
export default RevisionAddCard;
